import {Component, forwardRef, Inject} from "@angular/core";
import {SmartsheetTokenModel} from "./smartsheet-token.model";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {SmartsheetService} from "./smartsheet.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {toggleLoading} from "../misc/loading.decorator";
import {SmartsheetWorkspaceModel} from "./smartsheet-workspace.model";
import {FilteredList} from "../helpers/filtered-list";

export interface SmartsheetWorkspaceDialogInput {
  projectId: string;
  hasExistingIntegration: boolean;
}

export interface SmartsheetWorkspaceInfo {
  smartsheetWorkspace: SmartsheetWorkspaceModel;
  token: SmartsheetTokenModel;
}

@Component({
  templateUrl: "./smartsheet-workspace-list.dialog.template.pug",
})
export class SmartsheetWorkspaceListDialogComponent
  extends DialogComponent<SmartsheetWorkspaceDialogInput, SmartsheetWorkspaceInfo>
  implements SmartsheetWorkspaceDialogInput {
  error: Error;
  loading: boolean;
  projectId: string;
  hasExistingIntegration: boolean;

  result: SmartsheetWorkspaceInfo = undefined;
  token: SmartsheetTokenModel = undefined;

  workspaces: FilteredList<SmartsheetWorkspaceModel> = new FilteredList<SmartsheetWorkspaceModel>({
    startingPageSize: 5,
    searchKeys: ["name"],
    exactMatchSearchKeys: ["id"],
  });

  constructor(
    public dialogService: DialogService,
    @Inject(forwardRef(() => SmartsheetService)) private smartsheetService: SmartsheetService,
  ) {
    super(dialogService);
  }

  @toggleLoading()
  async loadWorkspaces() {
    this.workspaces.items = await this.smartsheetService.getWorkspaceList(this.token);
  }

  @handleErrors()
  async logIn() {
    this.token = await this.smartsheetService.logIn();
    await this.loadWorkspaces();
  }

  @handleErrors()
  async select(smartsheetWorkspace: SmartsheetWorkspaceModel) {
    this.result = {
      smartsheetWorkspace,
      token: this.token,
    };

    await this.smartsheetService.saveSmartsheetWorkspace(this.token, smartsheetWorkspace, this.projectId);

    this.close();
  }

  @handleErrors()
  async clear() {
    const token = null;
    const smartsheetWorkspace = new SmartsheetWorkspaceModel();

    this.result = {smartsheetWorkspace, token};

    await this.smartsheetService.saveSmartsheetWorkspace(token, smartsheetWorkspace, this.projectId);

    this.close();
  }

  cancel() {
    this.result = undefined;
    this.close();
  }
}
